import React, { FC, useState } from "react"
import styled from "@emotion/styled"
import { useTranslation } from "react-i18next"
import { mobileFirstDevice } from "@/utils/media-queries"
import { Row, Col } from "react-grid-system"
import { values } from "./data"
import { css } from "@emotion/css"
import { getWordBreak } from "../Text"

interface ValueProps {
  light?: boolean
  isSelected?: boolean
  visible?: boolean
}

const ValueSelector = styled(Col)`
  overflow: none;
`

const ValueContainer = styled(Row, {
  shouldForwardProp: prop => prop !== "light",
})<{ light: boolean }>`
  width: 100%;
  border-left: ${({ light }) =>
    `1px solid rgba(${light ? "0, 0, 0" : "244, 244, 244"}, 0.4)`};
  border-bottom: 0;
  margin: 0 0 !important;
`

const ValueOption = styled(Col)`
  border-bottom: none;
  cursor: pointer;
  margin-bottom: 0;
  padding: 0 0 30px 0 !important;
`

const ValueOptionText = styled.div<ValueProps>`
  opacity: ${props => (props.isSelected ? 1 : 0.4)};
  color: ${({ theme, light }) =>
    light ? theme.colors.black : theme.colors.titleText};
  border-left: ${({ light, isSelected, theme }) =>
    isSelected
      ? `1px solid ${light ? theme.colors.black : theme.colors.titleText}`
      : "none"};
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.1em;
  line-height: 145%;
  margin-left: -1px;
  padding-left: 30px;
  text-align: left;
  @media ${mobileFirstDevice.tablet} {
    letter-spacing: 0;
  }

  @media ${mobileFirstDevice.laptop} {
    font-size: 32px;
    line-height: 125%;
  }
`

const Description = styled.span<ValueProps>`
  color: ${({ theme, light }) => (light ? "#565F76" : theme.colors.tokenText)};
  display: ${({ visible }) => (visible ? "block" : "none")};
  font-size: 16px;
  font-weight: 600;
  line-height: 135%;
  max-width: 654px;
  padding: 0 24px 24px 0;
  text-align: left;
  white-space: pre-wrap;
  @media ${mobileFirstDevice.laptop} {
    font-size: 32px;
    line-height: 125%;
  }
`

const Web: FC<{ light: boolean }> = ({ light }) => {
  const [current, setCurrent] = useState(0)
  const { t, i18n } = useTranslation("values")

  return (
    <Row>
      <Col
        xs={4}
        className={css`
          overflow: none;
        `}
      >
        <ValueContainer light={light}>
          {values.map((title, index) => {
            return (
              <ValueOption
                xs={12}
                onClick={() => {
                  setCurrent(index)
                }}
                key={title}
              >
                <ValueOptionText
                  light={light}
                  isSelected={index === current}
                  style={{ wordBreak: getWordBreak(i18n.language) }}
                >
                  {t(`values.${index}_title`)}
                </ValueOptionText>
              </ValueOption>
            )
          })}
        </ValueContainer>
      </Col>
      <Col xs={8}>
        {values.map((title, index) => (
          <Description
            key={title}
            visible={index === current}
            light={light}
            dangerouslySetInnerHTML={{
              __html: t(`values.${index}_description`).replace(/\n/g, "<br />"),
            }}
            style={{ wordBreak: getWordBreak(i18n.language) }}
          />
        ))}
      </Col>
    </Row>
  )
}

export default Web
